__turbopack_context__.v({
  "body": "index-module-scss-module__0DlyKa__body",
  "icon": "index-module-scss-module__0DlyKa__icon",
  "iconBlock": "index-module-scss-module__0DlyKa__iconBlock",
  "iconWrapper": "index-module-scss-module__0DlyKa__iconWrapper",
  "textWrapper": "index-module-scss-module__0DlyKa__textWrapper",
  "title": "index-module-scss-module__0DlyKa__title",
});
